import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { setAuthState } from './features/auth/authSlice';
import { InteractionStatus, AccountInfo } from '@azure/msal-browser';
import MainApp from './MainApp';

const MsalInitializer = () => {
    const dispatch = useDispatch();
    const { instance, accounts, inProgress } = useMsal();
    const [isMsalInitialized, setIsMsalInitialized] = useState(false);

    useEffect(() => {
        const handleMsalRedirect = async () => {
            try {
                const response = await instance.handleRedirectPromise();
                if (response && response.account) {
                    dispatch(setAuthState({ isAuthenticated: true, account: response.account }));
                }
            } catch (error) {
                console.error("Redirect promise error:", error);
            } finally {
                setIsMsalInitialized(true);
            }
        };

        handleMsalRedirect();
    }, [dispatch, instance]);

    useEffect(() => {
        // Sync Redux state with MSAL state after initialization
        if (isMsalInitialized && accounts.length > 0 && inProgress === InteractionStatus.None) {
            const account = accounts[0] as AccountInfo;
            dispatch(setAuthState({ isAuthenticated: true, account: account }));
        } else if (isMsalInitialized && !accounts.length && inProgress === InteractionStatus.None) {
            dispatch(setAuthState({ isAuthenticated: false, account: null }));
        }
    }, [dispatch, isMsalInitialized, accounts, inProgress]);

    if (!isMsalInitialized) {
        return <div>Initializing authentication...</div>;
    }

    return <MainApp />;
};

export default MsalInitializer;